import { memo } from "react";
import { StyleProp, View, ViewStyle } from "react-native";
import useRenderGatheringHeaderWheelItem from "src/components/GatheringHeader/hooks/useRenderGatheringHeaderWheelItem";
import { GatheringHeaderProps } from "src/components/GatheringHeader/types";
import Wheel from "src/components/Wheel";
import useDim from "src/hooks/useDim";
import GatheringHeaderThumbnailImage from "../../GatheringHeaderThumbnailImage";

const GatheringHeaderRegularThumbnail = ({
	wheelData,
	renderWheelItem,
	thumbnailUrl_1x1,
	wheelDataLoading,
	containerStyle,
	renderThumbnailOverlay,
}: Pick<
	GatheringHeaderProps,
	| "wheelData"
	| "renderWheelItem"
	| "thumbnailUrl_1x1"
	| "wheelDataLoading"
	| "renderThumbnailOverlay"
> & {
	containerStyle?: StyleProp<ViewStyle>;
}) => {
	const { height } = useDim();
	const fullHeight = 0.7 * height;
	const clippedHeight = 0.4 * height;
	const { renderItem } = useRenderGatheringHeaderWheelItem({
		renderWheelItem,
		wheelDataLoading,
	});

	return (
		<View
			style={[
				{
					flex: 1,
					minHeight: clippedHeight,
					alignItems: "flex-end",
					justifyContent: "center",
				},
				containerStyle,
			]}
		>
			<Wheel
				containerStyle={{
					position: "absolute",
				}}
				size={fullHeight}
				data={wheelData}
				renderItem={renderItem}
			>
				<GatheringHeaderThumbnailImage thumbnailUrl_1x1={thumbnailUrl_1x1} />
				{renderThumbnailOverlay?.()}
			</Wheel>
		</View>
	);
};
export default memo(GatheringHeaderRegularThumbnail);
